module.exports = __webpack_public_path__ + "static/Video Conference App-a34d0513e8611165b1cb816d75259f94.svg";